module.exports = __webpack_public_path__ + "static/media/MuscoVision_with-tag-gray-01.30ac5414.svg";